import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getStyles } from './styles';

export function CreationMethodSubTitle(props) {
  const {
    i18n,
    subTitle,
  } = props;

  const classes = useDefaultStyles(getStyles);

  return (
    <div
      className={classNames('creation-method-sub-title', classes.subTitleContainer)}
    >
      {i18n.getString(subTitle)}
    </div>
  );
}

CreationMethodSubTitle.propTypes = {
  i18n: PropTypes.shape({ getString: PropTypes.func.isRequired }).isRequired,
  subTitle: PropTypes.string,
};

CreationMethodSubTitle.defaultProps = {
  subTitle: _TL_('You can create new campaign from scratch, or import your previous campaign from Google or Facebook.'),
};
